<i18n>
{
    "de": {
        "hinweis": "Das Produkt konnte nicht gefunden werden. Bitte laden Sie die Seite neu oder gehen Sie zur Produktübersicht.",
        "ipDriverAnfrage": "IP Driver auf Anfrage",
        "ausschnittmaßEinbautiefeRücksicht": "Ausschnittmaß und Einbautiefe der Leuchte und Driverabmessungen berücksichtigen",
        "driverExtern": "Driver extern platzieren",
        "reihenschaltung": "Reihenschaltung",
        "primaryWiring": "Für primäre Durchgangsverdrahtung geeignet",
        "transformer": "Transformatoren",
        "junctionBoxes": "Für Montage auf Geräte- und Hohlwanddosen (Ø 68 mm) geeignet",
        "lamp": "LED",
        "powerSupply": "Anschluss",
        "mountingDepth": "Einbautiefe (H)",
        "farben": "Farben",
        "weitereFarben": "Weitere Farben",
        "weitereBilder": "Weitere Bilder",
        "detailinformationen": "Detailinformationen",
        "datasheet": "Technisches Datenblatt",
        "legend": "Legende",
        "bezeichnung": "bezeichnung",
        "codeExplanation": "Code-Erklärung"
    },
    "en": {
        "hinweis": "No product found. Please reload the page or go to the products overview.",
        "ipDriverAnfrage": "IP Driver on request",
        "ausschnittmaßEinbautiefeRücksicht": "Accommodate cut out and recessed depth of luminare and dimension of driver",
        "driverExtern": "Place driver remotely",
        "reihenschaltung": "Series connection",
        "primaryWiring": "For primary feed-through wiring",
        "transformer": "Transformer",
        "junctionBoxes": "Suitable for mounting on junction boxes (Ø 68 mm)",
        "lamp": "LED",
        "powerSupply": "Power Supply",
        "mountingDepth": "Mounting Depth (H)",
        "farben": "Colours",
        "weitereFarben": "More Colours",
        "weitereBilder": "More Images",
        "detailinformationen": "Detail informations",
        "datasheet": "Technical Data Sheet",
        "legend": "Legend",
        "bezeichnung": "bezeichnung_en",
        "codeExplanation": "Code-Explanation"
    }
}
</i18n>

<template>
  <div class="c-productpage">
    <loader v-if="isLoading" />
    <div
      class="container my-5"
      v-else-if="Object.keys(this.product).length === 0"
    >
      {{ $t("hinweis") }}
    </div>
    <div class="container" v-else>
      <div class="row mb-5">
        <div class="col-24 col-lg-12 mb-4">
          <div
            class="c-image-wrapper"
            :class="{ '-ground': categories.find((obj) => obj.id === '9') }"
            @click="openProductImage(productImage)"
            style="cursor: pointer;"
          >
            <a
              :href="productImage"
              class="glightbox2 u-pointer-events-none"
              :data-gradient="true"
            >
              <img
                class="c-image"
                v-lazy="hoverImage ? imageurl + hoverImage : productImage"
                :alt="product.titel"
                width="540"
                height="540"
              />
              <div class="c-badge" v-if="product.new === 1">
                <img
                  :src="root + 'resources/img/star.svg'"
                  alt="Neuheit Stern"
                  width="12"
                />
                {{ $t("neuheit") }}
              </div>
              <div class="c-badge" v-if="product.coming_soon === 1">
                <img
                  :src="root + 'resources/img/star.svg'"
                  alt="Neuheit Stern"
                  width="12"
                />
                {{ $t("coming_soon") }}
              </div>
              <!-- <div class="c-cutout" v-if="product.ausschnitt_icon">
                <img :src="imageurl + product.ausschnitt_icon" height="29" />
                <div v-if="product.ausschnitt_mass">
                  {{ product.ausschnitt_mass }}
                </div>
              </div> -->
            </a>
          </div>
          <div class="c-thumbs" ref="thumbs">
            <template v-for="(entry, index) in gallery">
              <a
                v-if="index < thumbsGridColumnCount - 1"
                :key="index"
                :href="imageurl + entry"
                class="glightbox"
                :data-copyright="copyrights[entry]"
                :data-gradient="true"
              >
                <div
                  class="c-thumbs__imagewrapper"
                  :class="{ '-ground': categories.includes('9') }"
                >
                  <div
                    class="c-thumbs__image"
                    v-lazy:background-image="
                      root +
                        'index.php?rex_media_type=product_gallery_thumbnail&rex_media_file=' +
                        entry
                    "
                  ></div>
                </div>
              </a>
            </template>
            <div
              class="c-collapsible mt-2"
              v-if="gallery.length > thumbsGridColumnCount - 1"
              :style="{
                order: '1',
                'grid-column': '1/-1',
              }"
            >
              <div class="c-colors__title c-collapsible__button pl-1 py-2">
                <b>{{ $t("weitereBilder") }}</b>
              </div>
              <div class="c-collapsible__content px-0">
                <div class="c-thumbs py-2">
                  <template v-for="(entry, index) in gallery">
                    <a
                      v-if="index >= thumbsGridColumnCount - 1"
                      :key="index"
                      :href="imageurl + entry"
                      class="glightbox"
                      :data-copyright="copyrights[entry]"
                      :data-gradient="true"
                    >
                      <div
                        class="c-thumbs__imagewrapper"
                        :class="{ '-ground': categories.includes('9') }"
                      >
                        <div
                          class="c-thumbs__image"
                          v-lazy:background-image="
                            root +
                              'index.php?rex_media_type=product_gallery_thumbnail&rex_media_file=' +
                              entry
                          "
                        ></div>
                      </div>
                    </a>
                  </template>
                </div>
              </div>
            </div>
            <a
              :href="imageurl + product.skizze_zentriert"
              class="glightbox u-grid-column-last"
              v-if="product.skizze_zentriert"
            >
              <div
                class="c-thumbs__image -sketch-centered"
                v-lazy:background-image="
                  root +
                    'index.php?rex_media_type=product_gallery_thumbnail&rex_media_file=' +
                    product.skizze_zentriert
                "
              ></div>
            </a>
            <a
              :href="imageurl + product.skizze"
              class="glightbox u-grid-column-last"
              v-else-if="product.skizze"
            >
              <div
                class="c-thumbs__image -sketch"
                v-lazy:background-image="
                  root +
                    'index.php?rex_media_type=product_gallery_thumbnail&rex_media_file=' +
                    product.skizze
                "
              ></div>
            </a>
          </div>
        </div>
        <div
          class="col-24 col-lg-11 offset-lg-1 flex-column"
          :class="{ 'd-flex': true }"
        >
          <div
            class="c-productpage__text"
            :class="{
              '-colorchips': colorImages.length === 0 || isChipInColorImages,
            }"
          >
            <h1 class="h2">{{ product.titel }}</h1>
            <div v-html="product.beschreibung_en" v-if="lang === 'en'"></div>
            <div v-html="product.beschreibung" v-else></div>
          </div>
          <div
            class="c-colors"
            v-if="colorNames.length > 0"
            :class="{ '-mb-collapsible': colorNames.length > 4 }"
          >
            <div class="c-colors__title">{{ $t("farben") }}</div>
            <div class="row no-gutters mt-1" @mouseleave="hoverImage = ''">
              <template v-for="(colorName, index) in colorNames">
                <div
                  v-if="index < 4"
                  :key="'colorImage-' + index"
                  class="col-6 pr-1"
                  @mouseover="changeHoverImage(index)"
                >
                  <!-- :class="{
                    'c-popover':
                      colorImages.length > 0 &&
                      colorChips[index] !== colorImages[index],
                  }" -->
                  <!-- <div class="c-popover__box" v-if="colorImages[index]">
                    <img :src="imageurl + colorImages[index]" />
                  </div> -->
                  <a
                    :href="
                      colorImagesHover &&
                      colorImagesHover[index] &&
                      colorImagesHover[index][0]
                        ? imageurl + colorImagesHover[index][0]
                        : imageurl + colorImages[index]
                    "
                    :class="
                      isHoverImage(index)
                        ? 'glightbox2'
                        : 'u-pointer-events-none'
                    "
                    :data-gradient="true"
                  >
                    <img
                      v-if="colorImages.length === 0 || isChipInColorImages"
                      v-lazy="
                        root +
                          'index.php?rex_media_type=product_color_thumbnail&rex_media_file=' +
                          colorChips[index]
                      "
                      width="170"
                      :alt="product.titel + ' ' + colorName + ' Thumbnail'"
                    />
                    <div
                      v-else
                      class="c-colors__image-wrapper"
                      :class="{
                        '-ground': categories.find((obj) => obj.id === '9'),
                      }"
                    >
                      <!-- <a
                      :href="
                        colorImagesHover &&
                        colorImagesHover[index] &&
                        colorImagesHover[index][0]
                          ? imageurl + colorImagesHover[index][0]
                          : imageurl + colorImages[index]
                      "
                      :class="
                        colorImagesHover &&
                        colorImagesHover[index] &&
                        colorImagesHover[index][0]
                          ? 'glightbox2'
                          : 'u-pointer-events-none'
                      "
                    > -->
                      <img
                        class="c-colors__image"
                        v-lazy="
                          root +
                            'index.php?rex_media_type=product_color_thumbnail&rex_media_file=' +
                            colorImages[index]
                        "
                        width="170"
                        height="170"
                        :alt="product.titel + ' ' + colorName + ' Thumbnail'"
                      />
                      <!-- </a> -->
                    </div>
                    <div class="c-colors__name">
                      {{ colorName }}
                      <div
                        v-html="
                          colorNamesAddition[index]
                            ? colorNamesAddition[index][0]
                            : ''
                        "
                      ></div>
                    </div>
                  </a>
                </div>
              </template>
            </div>
            <div class="c-collapsible" v-if="colorNames.length > 4">
              <div class="c-colors__title c-collapsible__button pl-1 py-2">
                <b>{{ $t("weitereFarben") }}</b>
              </div>
              <div class="c-collapsible__content px-0">
                <div class="row no-gutters mt-1" @mouseleave="hoverImage = ''">
                  <template v-for="(colorName, index) in colorNames">
                    <div
                      v-if="index >= 4"
                      :key="'colorImage-' + index"
                      class="col-6 pr-1"
                      @mouseover="changeHoverImage(index)"
                    >
                      <!-- :class="{
                        'c-popover':
                          colorImages.length > 0 &&
                          colorChips[index] !== colorImages[index],
                      }" -->
                      <!-- <div class="c-popover__box" v-if="colorImages[index]">
                        <img :src="imageurl + colorImages[index]" />
                      </div> -->
                      <a
                        :href="
                          colorImagesHover &&
                          colorImagesHover[index] &&
                          colorImagesHover[index][0]
                            ? imageurl + colorImagesHover[index][0]
                            : imageurl + colorImages[index]
                        "
                        :class="
                          isHoverImage(index)
                            ? 'glightbox2'
                            : 'u-pointer-events-none'
                        "
                        :data-gradient="true"
                      >
                        <img
                          v-if="colorImages.length === 0 || isChipInColorImages"
                          v-lazy="
                            root +
                              'index.php?rex_media_type=product_color_thumbnail&rex_media_file=' +
                              colorChips[index]
                          "
                          width="170"
                          :alt="product.titel + ' ' + colorName + ' Thumbnail'"
                        />
                        <div
                          v-else
                          class="c-colors__image-wrapper"
                          :class="{
                            '-ground': categories.find((obj) => obj.id === '9'),
                          }"
                        >
                          <!-- <a
                          :href="
                            colorImagesHover &&
                            colorImagesHover[index] &&
                            colorImagesHover[index][0]
                              ? imageurl + colorImagesHover[index][0]
                              : imageurl + colorImages[index]
                          "
                          :class="
                            colorImagesHover &&
                            colorImagesHover[index] &&
                            colorImagesHover[index][0]
                              ? 'glightbox2'
                              : 'u-pointer-events-none'
                          "
                        > -->
                          <img
                            class="c-colors__image"
                            v-lazy="
                              root +
                                'index.php?rex_media_type=product_color_thumbnail&rex_media_file=' +
                                colorImages[index]
                            "
                            width="170"
                            height="170"
                            :alt="
                              product.titel + ' ' + colorName + ' Thumbnail'
                            "
                          />
                          <!-- </a> -->
                        </div>
                        <div class="c-colors__name">
                          {{ colorName }}
                          <div
                            v-html="
                              colorNamesAddition[index]
                                ? colorNamesAddition[index][0]
                                : ''
                            "
                          ></div>
                        </div>
                      </a>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            class="c-colors mt-4"
            v-else
            :class="{ 'mb-0': colors.length > 4 }"
          >
            <div class="c-colors__title">{{ $t("farben") }}</div>
            <div class="row no-gutters mt-1">
              <div
                v-for="(color, index) in colors"
                :key="'colorImage-' + index"
                class="col-6 pr-1"
              >
                <template v-if="index < 4">
                  <img :src="imageurl + color.attributes.farbchip" />
                  <div class="c-colors__name">
                    {{ colorNames[index] }}
                    <div>{{ color.attributes[$t("bezeichnung")] }}</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="c-collapsible" v-if="colors.length > 4">
              <div class="c-colors__title c-collapsible__button pl-1 py-2">
                <b>{{ $t("weitereFarben") }}</b>
              </div>
              <div class="c-collapsible__content px-0">
                <div class="row no-gutters mt-1">
                  <div
                    v-for="(color, index) in colors"
                    :key="'colorImage-' + index"
                    class="col-6 pr-1"
                  >
                    <template v-if="index >= 4">
                      <img :src="imageurl + color.attributes.farbchip" />
                      <div class="c-colors__name">
                        {{ colorNames[index] }}
                        <div>{{ color.attributes[$t("bezeichnung")] }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div
                        class="d-none d-xl-block mt-5"
                        v-html="product.content_oben"
                        v-if="product.content_oben"
                    ></div> -->
        </div>
      </div>
      <div class="mb-5" style="font-size: small">
        <div v-if="lang === 'en'" v-html="product.content_en_oben"></div>
        <div v-else v-html="product.content_oben"></div>
      </div>
      <div class="container -small">
        <!-- <div class="c-colors mt-4 mb-5" v-if="colorImages.length > 4">
          <div class="c-colors__title">{{ $t("farben") }}</div>
          <div class="row no-gutters">
            <div
              v-for="(colorImage, index) in colorImages"
              :key="'colorImage-' + index"
              class="col-6 col-lg-4 pr-1"
            >
              <img :src="imageurl + colorImage" />
              <div class="c-colors__name">
                {{ colorNames[index] }}
                <div
                  v-html="
                    colorNamesAddition[index]
                      ? colorNamesAddition[index][0]
                      : ''
                  "
                ></div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="mb-5" style="font-size: small">
          <div v-if="lang === 'en'" v-html="product.content_en_oben"></div>
          <div v-else v-html="product.content_oben"></div>
        </div> -->
        <table-by-type
          :table="tableByType"
          :tableheader="['Code', $t('lamp'), lumenText, $t('powerSupply')]"
          :classes="['', '', 'u-text-right u-p-right', '']"
          :showLumenInfo="showLumenInfo"
          v-if="Object.keys(tableByType).length > 0"
          :beamAngles="beamAngles"
          :colorNamesMapping="colorNamesMapping"
        ></table-by-type>
        <table-by-type
          :table="tableCriByType"
          :tableheader="[
            'Code',
            $t('lamp'),
            lumenText,
            $t('powerSupply'),
            'CRI',
          ]"
          :classes="['', '', 'u-text-right u-p-right', '', '']"
          :showLumenInfo="showLumenInfo"
          v-if="Object.keys(tableCriByType).length > 0"
          :beamAngles="beamAngles"
          :colorNamesMapping="colorNamesMapping"
        ></table-by-type>
        <table-by-type
          :table="tableHByType"
          :tableheader="[
            'Code',
            $t('lamp'),
            lumenText,
            $t('powerSupply'),
            $t('mountingDepth'),
          ]"
          :classes="['', '', 'u-text-right u-p-right', '', 'u-text-right']"
          :showLumenInfo="showLumenInfo"
          v-if="Object.keys(tableHByType).length > 0"
          :beamAngles="beamAngles"
          :colorNamesMapping="colorNamesMapping"
        ></table-by-type>
        <div class="row c-tableinfo align-items-center">
          <div class="col-24 col-lg-auto" v-if="product.eulumdat === 1">
            <span v-if="lang === 'en'"
              >Photometric data (EULUMDAT) on request</span
            >
            <span v-else>Photometrische Daten (EULUMDAT) auf Anfrage</span>
          </div>
          <div class="col-24 col-lg-auto" v-if="showLumenInfo">
            <span v-if="lang === 'en'">* Lumen data are nominal data</span>
            <span v-else>* Lumenangaben sind Nominalwerte</span>
          </div>
          <!-- <div class="col-24 col-lg-auto" v-if="showHInfo">
            <span v-if="lang === 'en'">** H = recessed depth</span
            ><span v-else>** H = Einbautiefe</span>
          </div> -->
          <div class="col-24 col-lg-auto" v-if="product.four_k_led === 1">
            <span v-if="lang === 'en'">*** 4000K LED on request</span>
            <span v-else>*** 4000K LED auf Anfrage</span>
          </div>
          <div class="col-24 col-lg-auto" v-if="product.dali_driver === 1">
            <span v-if="lang === 'en'">DALI driver on request</span>
            <span v-else>DALI-Driver auf Anfrage</span>
          </div>
          <div class="col-24 col-lg-auto" v-if="product.junction_boxes === 1">
            <span>{{ $t("junctionBoxes") }}</span>
          </div>
          <!-- <div class="col-24 col-lg-auto ml-auto"> -->
          <a
            v-if="product.code_erklaerung === 1"
            href="#"
            class="col-24 col-lg-auto ml-auto d-inline-flex align-items-center"
            data-toggle="modal"
            data-target="codeExplanationModal"
          >
            <img
              height="30"
              width="30"
              :src="imageurl + 'icon_info.svg'"
              class="mr-2"
              style=" pointer-events: none; "
              alt="Code-Erklärung Icon"
            />
            {{ $t("codeExplanation") }}</a
          >
          <!-- </div> -->
        </div>
        <!-- <div class="mt-3" v-if="product.transformator === '1'">
                    <a :href="imageurl + 'trafo_info_en_1.jpg'" target="_blank"
                        ><img
                            :src="root + 'resources/img/arrow-right.png'"
                        />&nbsp;Transformator</a
                    >
                </div> -->
        <!-- <div v-if="drivers.length > 0"> -->
        <!-- <div class="c-highlight">Driver</div>
                    <div class="u-border-t"></div>
                    <driver
                        v-for="(driver, index) in drivers"
                        :key="index"
                        :driver="driver"
                    ></driver>
                    <div class="row c-tableinfo">
                        <div class="col-24 col-lg-auto">
                            <sup>1</sup> {{ $t("ipDriverAnfrage") }}
                        </div>
                        <div class="col-24 col-lg-auto">
                            <sup>2</sup>
                            {{ $t("ausschnittmaßEinbautiefeRücksicht") }}
                        </div>
                        <div class="col-24 col-lg-auto">
                            <sup>3</sup> {{ $t("driverExtern") }}
                        </div>
                    </div> -->

        <!-- <div class="c-collapsible">
                        <div class="c-collapsible__button">
                            <b>Driver</b>
                        </div>
                        <div class="c-collapsible__content">
                            <div class="c-drivers">
                                <div
                                    class="row u-font-bold u-uppercase py-3 c-drivers__tableheader"
                                >
                                    <div class="col">Code</div>
                                    <div class="col">Power</div>
                                    <div class="col">Constant</div>
                                    <div class="col">Dimmable</div>
                                    <div class="col">L x W x H</div>
                                    <div class="col">Lamps</div>
                                </div>
                                <div
                                    v-for="(driver, index) in drivers"
                                    class="row py-2"
                                    :key="'driver-' + index"
                                >
                                    <div class="col">{{ driver.code }}</div>
                                    <div class="col">
                                        <div
                                            v-for="powerEntry of driver.power"
                                            :key="powerEntry.id"
                                        >
                                            {{ powerEntry }}
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div
                                            v-for="constantEntry of driver.constant"
                                            :key="constantEntry.id"
                                        >
                                            {{ constantEntry }}
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div
                                            v-for="dimmableEntry of driver.dimmable"
                                            :key="dimmableEntry.id"
                                        >
                                            {{ dimmableEntry }}
                                        </div>
                                    </div>
                                    <div class="col">{{ driver.size }}</div>
                                    <div class="col">
                                        {{ driver.lights_number }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
        <!-- </div> -->
        <!-- <div class="mt-3" v-if="product.driver === '1'">
                    <a
                        :href="imageurl + 'dls_driver_info_2020-11.pdf'"
                        target="_blank"
                        ><img
                            :src="root + 'resources/img/arrow-right.png'"
                        />&nbsp;Alle Driver</a
                    >
                </div> -->
        <h2 class="c-highlight">
          {{ $t("detailinformationen") }}
        </h2>
        <div class="u-border-t"></div>
        <div class="c-collapsible">
          <h3 class="-no-style c-collapsible__button">
            <b v-if="lang === 'en'">Technical Details</b>
            <b v-else>Technische Details</b>
          </h3>
          <div class="c-collapsible__content">
            <div class="my-3">
              <img
                v-for="(icon, index) in icons"
                :key="index"
                :src="imageurl + icon"
                height="46"
                class="c-icon"
                alt="Technisches Detail Icon"
              />
              <div class="c-cutout" v-if="product.ausschnitt_icon">
                <img
                  :src="imageurl + product.ausschnitt_icon"
                  height="29"
                  style="height: 29px;"
                />
                <div v-if="product.ausschnitt_mass">
                  {{ product.ausschnitt_mass }}
                </div>
              </div>
              <div class="mt-3">
                <a
                  target="_blank"
                  :href="
                    root + 'datasheets/datasheet-' + flatProductTitle + '.pdf'
                  "
                  class="d-inline-flex align-items-center mr-5 u-whitespace-nowrap"
                  ><img
                    height="35"
                    width="35"
                    :src="imageurl + 'pdf_icon.svg'"
                    class="mr-2"
                    alt="Technisches Datenblatt Icon"
                    style="height: 35px;"
                  />{{ $t("datasheet") }}</a
                >
                <!-- </div>
              <div class="mt-2"> -->
                <a
                  href="#"
                  class="d-inline-flex align-items-center mt-2"
                  data-toggle="modal"
                  data-target="legendModal"
                >
                  <img
                    height="35"
                    width="35"
                    :src="imageurl + 'icon_legende.svg'"
                    class="mr-2"
                    style=" pointer-events: none; height: 35px;"
                    alt="Legende Icon"
                  />
                  {{ $t("legend") }}</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="" v-if="equipment.length > 0">
          <div class="c-collapsible">
            <h3 class="-no-style c-collapsible__button">
              <b v-if="lang === 'en'">Accessories</b>
              <b v-else>Zubehör</b>
            </h3>
            <div class="c-collapsible__content">
              <div class="my-4">
                <div
                  v-for="(entry, index) in equipment"
                  class="row c-equipment"
                  :key="'equipment-' + index"
                >
                  <div class="col-auto" v-if="entry.bild">
                    <!-- <img
                      v-if="product.titel === 'CLIPPO'"
                      width="200"
                      :src="imageurl + entry.bild"
                    /> -->
                    <img
                      width="200"
                      :src="imageurl + entry.bild"
                      :alt="entry.titel"
                    />
                  </div>
                  <div class="col-auto d-block d-lg-none" v-if="entry.skizze">
                    <img
                      width="200"
                      :src="imageurl + entry.skizze"
                      :alt="entry.titel + ' Skizze'"
                    />
                  </div>
                  <div class="u-w-full d-block d-lg-none"></div>
                  <div class="col-24 col-sm">
                    <b v-if="lang === 'en'">{{ entry.titel_en }}</b>
                    <b v-else>{{ entry.titel }}</b>
                    <div
                      v-html="entry.beschreibung_en"
                      v-if="lang === 'en'"
                    ></div>
                    <div v-html="entry.beschreibung" v-else></div>
                    <equipment-table
                      :entry="entry"
                      class="d-none d-md-block"
                    ></equipment-table>
                    <!-- <div
                                            class="row c-equipment__tableheader py-2"
                                        >
                                            <div class="col">Code</div>
                                            <div class="col">Type</div>
                                            <div class="col">Colour</div>
                                        </div>
                                        <div
                                            class="row py-2"
                                            v-for="(row,
                                            rowIndex) in JSON.parse(
                                                entry.tabelle
                                            )"
                                            :key="'rowIndex-' + rowIndex"
                                        >
                                            <div
                                                class="col"
                                                v-for="(col, colIndex) in row"
                                                :key="'colIndex-' + colIndex"
                                            >
                                                {{ col }}
                                            </div>
                                        </div> -->
                  </div>
                  <div class="col-24 d-block d-md-none">
                    <equipment-table :entry="entry"></equipment-table>
                  </div>
                  <div class="col-6 d-none d-lg-block">
                    <img
                      v-if="entry.skizze"
                      width="200"
                      :src="imageurl + entry.skizze"
                      :alt="entry.titel + ' Skizze'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="drivers.length > 0">
          <div class="c-collapsible">
            <h3 class="-no-style c-collapsible__button" id="Driver">
              <b
                >Driver
                <!-- <template v-if="product.constant"
                                    >{{ product.constant }} mA</template
                                > -->
              </b>
            </h3>
            <div class="c-collapsible__content c-drivers">
              <!-- <template v-for="driverVersion in sortedDriverVersions">
                <driver-version
                  v-if="driverVersions[driverVersion]"
                  :drivers="driverVersions[driverVersion]"
                  :version="driverVersion"
                  :key="driverVersion"
                  :productTitel="product.titel"
                />
              </template> -->
              <template v-for="driverVersion in sortedDriverVersionsFromDb">
                <driver-version
                  v-if="driverVersions[driverVersion]"
                  :drivers="driverVersions[driverVersion]"
                  :version="driverVersion"
                  :key="driverVersion"
                  :productTitel="product.titel"
                />
              </template>
              <template
                v-for="(driverVersionValue, driverVersionKey) in driverVersions"
              >
                <driver-version
                  v-if="
                    !sortedDriverVersions.includes(driverVersionKey) &&
                      !sortedDriverVersionsFromDb.includes(driverVersionKey)
                  "
                  :drivers="driverVersionValue"
                  :version="driverVersionKey"
                  :key="driverVersionKey"
                  :productTitel="product.titel"
                />
              </template>
              <!-- <div class="c-drivers__grid">
                                <div class="c-drivers__tableheader">Code</div>
                                <div
                                    class="c-drivers__tableheader u-text-right"
                                >
                                    Power
                                </div>
                                <div
                                    class="c-drivers__tableheader u-text-right d-none d-md-block"
                                >
                                    Constant
                                </div>
                                <div
                                    class="c-drivers__tableheader u-text-center"
                                >
                                    Dimmable
                                </div>
                                <div
                                    class="c-drivers__tableheader u-text-right"
                                >
                                    LxWxH (mm)
                                </div>
                                <div
                                    class="c-drivers__tableheader u-text-center"
                                >
                                    Lamps
                                </div>
                                <template
                                    v-for="(driver, index) in drivers"
                                    class="row py-2"
                                >
                                    <div :key="'drivercode-' + index">
                                        {{ driver.code }}
                                    </div>
                                    <div
                                        :key="'driverpower-' + index"
                                        class="u-text-right"
                                    >
                                        <div
                                            v-for="powerEntry of driver.power"
                                            :key="powerEntry.id"
                                        >
                                            {{ powerEntry }} W
                                        </div>
                                    </div>
                                    <div
                                        :key="'driverconstant-' + index"
                                        class="u-text-right d-none d-md-block"
                                    >
                                        <div
                                            v-for="constantEntry of driver.constant"
                                            :key="constantEntry.id"
                                        >
                                            {{ constantEntry }} mA
                                        </div>
                                    </div>
                                    <div
                                        :key="'driverdim-' + index"
                                        class="u-text-center"
                                    >
                                        <div
                                            v-for="dimmableEntry of driver.dimmable"
                                            :key="dimmableEntry.id"
                                        >
                                            {{ dimmableEntry }}
                                        </div>
                                    </div>
                                    <div
                                        :key="'driversize-' + index"
                                        class="u-text-right"
                                    >
                                        {{ driver.size.replaceAll(" ", "") }}
                                    </div>
                                    <div
                                        :key="'driverlights-' + index"
                                        v-html="driver.lights_number"
                                        class="u-text-center"
                                    ></div>
                                </template>
                            </div> -->
              <div class="row c-tableinfo">
                <div class="col-24" v-if="showPrimaryWiring">
                  * {{ $t("primaryWiring") }}
                </div>
                <!-- <div class="col-24" v-if="product.ipdriver_request === 1">
                  {{ $t("ipDriverAnfrage") }}
                </div> -->
                <div
                  class="col-24"
                  v-if="showAusschnittmaßEinbautiefeRücksicht"
                >
                  <sup>1</sup>
                  {{ $t("ausschnittmaßEinbautiefeRücksicht") }}
                </div>
                <div
                  class="col-24"
                  v-if="product.driver_extern === 1 || showDriverExtern"
                >
                  <sup>2</sup> {{ $t("driverExtern") }}
                </div>
                <div class="col-24" v-if="showReihenschaltung">
                  <sup>3</sup>
                  {{ $t("reihenschaltung") }}
                </div>
              </div>
              <!-- <div class="my-3" v-if="product.driver === '1'">
                                <a
                                    :href="
                                        imageurl + 'dls_driver_info_2020-11.pdf'
                                    "
                                    target="_blank"
                                    ><img
                                        :src="
                                            root +
                                                'resources/img/arrow-right.png'
                                        "
                                    />&nbsp;Alle Driver</a
                                >
                            </div> -->
            </div>
          </div>
        </div>
        <div v-if="product.transformator === 1">
          <div class="c-collapsible">
            <h3 class="-no-style c-collapsible__button">
              <b>{{ $t("transformer") }}</b>
            </h3>
            <div class="c-collapsible__content c-drivers">
              <transformer />
            </div>
          </div>
        </div>
        <div class="" v-if="product.content || product.content_en">
          <div class="c-collapsible">
            <h3 class="-no-style c-collapsible__button">
              <b v-if="lang === 'en'">Other</b>
              <b v-else>Sonstiges</b>
            </h3>
            <div class="c-collapsible__content">
              <div class="my-4">
                <div v-html="product.content_en" v-if="lang === 'en'"></div>
                <div v-html="product.content" v-else></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="u-text-center mt-5">
      <router-link class="c-button" to="/"
        ><span v-if="lang === 'en'">Back to overview</span
        ><span v-else>Zurück zur Übersicht</span></router-link
      >
    </div>
    <slider
      :headline="lang === 'en' ? 'More Products' : 'Weitere Produkte'"
      :slides="relatedProductsSlides"
      id="related-products"
      showBullets
    ></slider>
    <slider
      headline="Inspiration"
      :slides="inspirationSlides"
      id="inspiration"
      hasLinks
    ></slider>
    <div class="u-text-center c-reference">
      <a
        class="c-button"
        :href="
          lang === 'en' ? root + 'en/inspirations' : root + 'de/inspiration'
        "
        ><span v-if="lang === 'en'">To the projects</span
        ><span v-else>Zu den Projekten</span></a
      >
    </div>

    <LegendModal />
    <CodeExplanationModal />
    <!-- Driver Modal -->
    <!-- <div id="driverModal" class="c-modal">
            <div class="c-modal__content">
                <span class="c-modal__close">&times;</span>
                <h2>Driver</h2>
                <h3>Technische Informationen Driver</h3>
                <img :src="imageurl + 'driver_info.jpg'" />
                <h3>Driver Verwendung</h3>
                <img :src="imageurl + 'driver_use.jpg'" />
            </div>
        </div> -->
  </div>
</template>

<script>
import TableByType from "@/components/TableByType";
import Slider from "@/components/Slider";
import Loader from "@/components/LoaderStar";
import DriverVersion from "@/components/DriverVersion";
import EquipmentTable from "@/components/EquipmentTable";
import Transformer from "@/components/Transformer";
import LegendModal from "@/components/LegendModal";
import CodeExplanationModal from "../components/CodeExplanationModal.vue";

export default {
  metaInfo() {
    const productsPath = this.lang === "en" ? "en/products/" : "de/produkte/";
    let categorySlug = "";
    if (this.categories[0]) {
      categorySlug =
        this.lang === "en"
          ? window.toSlug(this.categories[0].titel_en)
          : window.toSlug(this.categories[0].titel);
      categorySlug += "/";
    }
    let productSlug = "";
    if (this.product.titel) {
      productSlug = window.toSlug(this.product.titel);
    }
    const canonicalHref =
      "https://www.dlslighting.com/" +
      productsPath +
      categorySlug +
      productSlug;

    return {
      title: this.headTitle,
      link: [
        {
          rel: "canonical",
          href: canonicalHref,
        },
        //     {
        //         rel: "alternate",
        //         hreflang: "lang_code",
        //         href: this.root + "path",
        //     },
      ],
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            this.lang === "en"
              ? this.product.beschreibung_en
              : this.product.beschreibung,
        },
        {
          property: "og:title",
          content: this.product.titel + " - DLS Lighting",
          vmid: "og:title",
        },
        {
          property: "og:image",
          content: this.imageurl + this.product.produktbild,
          vmid: "og:image",
        },
        {
          property: "og:description",
          content:
            this.lang === "en"
              ? this.product.beschreibung_en
              : this.product.beschreibung,
          vmid: "og:description",
        },
      ],
    };
  },
  components: {
    TableByType,
    Slider,
    Loader,
    DriverVersion,
    EquipmentTable,
    Transformer,
    LegendModal,
    CodeExplanationModal,
  },
  props: {
    id: {
      required: true,
      type: String,
    },
    art: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {
      product: {},
      categories: [],
      equipment: [],
      drivers: [],
      gallery: [],
      icons: [],
      additionalImages: [],
      table: [],
      tableByType: {},
      tableCri: [],
      tableCriByType: {},
      tableH: [],
      tableHByType: {},
      showLumenInfo: false,
      showHInfo: false,
      imageurl: process.env.VUE_APP_IMAGEURL,
      relatedProductsSlides: [],
      inspirationSlides: [],
      root: process.env.VUE_APP_ROOT,
      isLoading: false,
      colorImages: [],
      colorImagesHover: [],
      colorNames: [],
      colorNamesMapping: {},
      colorChips: [],
      colorNamesAddition: [],
      showIpDriverAnfrage: false,
      showAusschnittmaßEinbautiefeRücksicht: false,
      showDriverExtern: false,
      showReihenschaltung: false,
      showPrimaryWiring: false,
      beamAngles: {},
      colors: [],
      hoverImage: "",
      copyrights: {},
      lightbox: null,
      lightbox2: null,
      sortedDriverVersions: [
        "-",
        "9.5 W LED dim to warm",
        "12.6 W LED dim to warm",
        "13 W LED dim to warm",
        "9.3 W LED 2700K",
        "9 W LED 2700K/3000K",
        "13 W LED 2700K/3000K",
        "14 W LED 2700K/3000K",
        "9.3 W LED module",
        "14 W LED module",
      ],
      sortedDriverVersionsFromDb: [],
      thumbsGridColumnCount: 6,
    };
  },
  mounted() {
    this.fillData();
    this.$nextTick(() => {
      this.setThumbsGridColumnCount();
    });
    if (Object.keys(this.product).length === 0) {
      this.isLoading = true;
    }
    this.$store
      .dispatch("getProduct", this.id)
      .then(() => {
        this.fillData();
        this.axios
          .get("drivers_to_products/?filter[product]=" + this.product.id)
          .then((response) => {
            if (response.status === 200) {
              for (let driverToProduct of response.data.data) {
                const foundDriver = this.drivers.find((driver) => {
                  return (
                    driver.id ===
                    driverToProduct.relationships.driver.data[0].id
                  );
                });
                if (foundDriver) {
                  const lights_number =
                    driverToProduct.attributes.lights_number;
                  // if (
                  //     lights_number.includes("<sup>1</sup>")
                  // ) {
                  //     this.showIpDriverAnfrage = true;
                  // }
                  if (lights_number.includes("<sup>1</sup>")) {
                    this.showAusschnittmaßEinbautiefeRücksicht = true;
                  }
                  if (lights_number.includes("<sup>2</sup>")) {
                    this.showDriverExtern = true;
                  }
                  if (lights_number.includes("<sup>3</sup>")) {
                    this.showReihenschaltung = true;
                  }
                  this.$set(foundDriver, "lights_number", lights_number);
                  const driverVersions =
                    driverToProduct.relationships.driver_version.data;
                  if (driverVersions.length) {
                    let driverVersionsString = "";
                    for (const [
                      driverVersionIndex,
                      driverVersion,
                    ] of driverVersions.entries()) {
                      driverVersionsString +=
                        driverVersion.attributes.bezeichnung;
                      if (driverVersionIndex + 1 < driverVersions.length) {
                        driverVersionsString += ",";
                      }
                    }
                    this.$set(foundDriver, "versions", driverVersionsString);
                  } else {
                    this.$set(
                      foundDriver,
                      "versions",
                      driverToProduct.attributes.version
                    );
                  }
                  this.$set(
                    foundDriver,
                    "versionConstants",
                    driverToProduct.attributes.constant
                  );
                  this.$set(
                    foundDriver,
                    "versionPowers",
                    driverToProduct.attributes.power
                  );
                }
              }
            }
          });
        this.axios
          .get(
            "related_products/?per_page=13&titel=" +
              this.product.titel.split(" ")[0] +
              "&category=" +
              this.art
          )
          .then((response) => {
            if (response.status === 200) {
              for (let product of response.data.data) {
                if (this.id !== product.attributes.id) {
                  let productSlide = {};
                  productSlide.id = product.attributes.id;

                  let productSlideImage = "";
                  if (
                    product.attributes.produktbild_transparent_thumbnail === 1
                  ) {
                    productSlideImage =
                      product.attributes.produktbild_transparent;
                  } else {
                    productSlideImage = product.attributes.thumbnail;
                  }
                  productSlide.image = productSlideImage;
                  productSlide.category =
                    product.relationships?.Kategorie?.data[0]?.attributes;

                  // console.log(product);

                  productSlide.title = product.attributes.titel;
                  productSlide.subtitle =
                    this.lang === "en"
                      ? product.relationships?.Kategorie?.data[0]?.attributes
                          .titel_en
                      : product.relationships?.Kategorie?.data[0]?.attributes
                          .titel;
                  this.relatedProductsSlides.push(productSlide);
                }
              }
            }
          });
        this.axios.get("imagecolornames/").then((response) => {
          if (response.status === 200) {
            // console.log(response.data.data);
            this.colorNamesMapping = {};
            for (const colorName of response.data.data) {
              this.colorNamesMapping[
                // this.product.titel +
                //   "&nbsp;&nbsp;" +
                colorName.attributes?.bezeichnung_en.split(" / ")[0]
              ] =
                // this.product.titel +
                // "&nbsp;&nbsp;" +
                colorName.attributes?.bezeichnung.split(" / ")[0];
            }
          }
        });
        this.axios.get("driver_versions/").then((response) => {
          if (response.status === 200) {
            this.sortedDriverVersionsFromDb = ["-"];
            for (const driverVersion of response.data.data) {
              this.sortedDriverVersionsFromDb.push(
                driverVersion.attributes?.bezeichnung
              );
            }
          }
        });
      })
      .finally(() => {
        this.isLoading = false;
        this.$nextTick(() => {
          this.setThumbsGridColumnCount();
          document
            .querySelectorAll('a[href^="#"]:not([href="#"])')
            .forEach((anchor) => {
              // console.log(anchor);
              const currentPath =
                window.location.pathname + window.location.search;
              anchor.setAttribute(
                "href",
                currentPath + anchor.getAttribute("href")
              );
            });
        });
        window.addEventListener("resize", this.setThumbsGridColumnCount);
      });
    this.axios.get("projects/").then((response) => {
      if (response.status === 200) {
        for (let project of response.data.data) {
          let projectSlide = {};
          projectSlide.id = project.attributes.id;
          projectSlide.image = project.attributes.thumbnail;
          projectSlide.title =
            this.lang === "en"
              ? project.attributes.titel_en
              : project.attributes.titel;
          projectSlide.subtitle = project.attributes.ort;
          const projectsPath =
            this.lang === "en" ? "en/inspirations/" : "de/inspiration/";
          projectSlide.link =
            this.root +
            projectsPath +
            projectSlide.title
              .toLowerCase()
              .replaceAll(" ", "-")
              .replaceAll(/\u00e4/g, "ae")
              .replaceAll(/\u00fc/g, "ue")
              .replaceAll(/\u00f6/g, "oe")
              .replace(/\-\-+/g, "-") +
            "-" +
            projectSlide.id +
            "/";
          this.inspirationSlides.push(projectSlide);
        }
      }
    });
    // this.axios.get("copyright/").then((response) => {
    //   if (response.status === 200) {
    //     for (let copyright of response.data.data) {
    //       if (this.lang === "en") {
    //         this.$set(
    //           this.copyrights,
    //           copyright.attributes.bild,
    //           copyright.attributes.copyright_en
    //         );
    //       } else {
    //         this.$set(
    //           this.copyrights,
    //           copyright.attributes.bild,
    //           copyright.attributes.copyright
    //         );
    //       }
    //     }
    //   }
    // });
  },
  unmounted() {
    window.removeEventListener("resize", this.setThumbsGridColumnCount);
  },
  watch: {
    gallery() {
      // this.initializeLightbox();
      this.reloadLightbox();
    },
    copyrights: {
      handler() {
        // this.initializeLightbox();
        this.reloadLightbox();
      },
      deep: true,
    },
  },
  methods: {
    setThumbsGridColumnCount() {
      const thumbsElement = this.$refs.thumbs;
      // console.log(thumbsElement);
      if (thumbsElement) {
        this.thumbsGridColumnCount = window
          .getComputedStyle(thumbsElement)
          .getPropertyValue("grid-template-columns")
          .split(" ").length;
        // console.log(this.thumbsGridColumnCount);
      }
    },
    // onImageMousemove(event) {
    //   var windowWidth = window.innerWidth;
    //   var windowHeight = window.innerHeight;
    //   var rect = event.target.getBoundingClientRect();

    //   var mouseXpercentage = Math.round((event.pageX / windowWidth) * 100);
    //   var mouseYpercentage = Math.round((event.pageY / windowHeight) * 100);

    //   document.getElementsByClassName("c-image-wrapper")[0].style.background =
    //     "radial-gradient(at " +
    //     mouseXpercentage +
    //     "% " +
    //     mouseYpercentage +
    //     "%, #f2f2f2, #929292)";
    // },
    reloadLightbox() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.lightbox) {
            this.lightbox.reload();
            // console.log("lightbox reloaded");
          }
        }, 0);
      });
    },
    changeHoverImage(index) {
      if (
        // this.isChipInColorImages
        // &&
        this.colorChips[index] !== this.colorImages[index]
      ) {
        if (this.colorImagesHover.length > 0) {
          if (this.colorImagesHover?.[index]?.[0]) {
            this.hoverImage = this.colorImagesHover[index][0];
          }
        } else if (this.colorImages[index]) {
          this.hoverImage = this.colorImages[index];
        }
      }
    },
    isHoverImage(index) {
      let result = false;
      if (this.colorChips[index] !== this.colorImages[index]) {
        if (this.colorImagesHover.length > 0) {
          if (this.colorImagesHover?.[index]?.[0]) {
            result = true;
          }
        } else if (this.colorImages[index]) {
          result = true;
        }
      }
      return result;
    },
    initializeLightbox() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.lightbox = GLightbox({
            slideHTML: `<div class="gslide">
                <div class="gslide-inner-content">
                    <div class="ginner-container">
                        <div class="gslide-media">
                          <div class="gslide-copyright-wrapper">
                            ©
                            <div class="gslide-copyright"></div>
                          </div>
                        </div>
                        <div class="gslide-description">
                            <div class="gdesc-inner">
                                <h4 class="gslide-title"></h4>
                                <div class="gslide-desc"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`,
            slideExtraAttributes: {
              copyright: "",
              gradient: "",
            },
            loop: true,
          });
          this.lightbox2 = GLightbox({
            selector: ".glightbox2",
            slideExtraAttributes: {
              gradient: "",
            },
            loop: true,
          });
          this.lightbox.on("open", () => {
            if (this.categories.find((obj) => obj.id === "9")) {
              document
                .getElementById("glightbox-body")
                .classList.add("-ground");
            }
          });
          this.lightbox2.on("open", (event) => {
            // console.log(event);
            if (this.categories.find((obj) => obj.id === "9")) {
              document
                .getElementById("glightbox-body")
                .classList.add("-ground");
            }
          });
          this.lightbox.on("slide_before_load", (slide) => {
            const { slideIndex, slideNode, slideConfig } = slide;
            // console.log(slide);
            const copyright = slideConfig.copyright;
            if (copyright) {
              slideNode.querySelector(
                ".gslide-copyright"
              ).innerHTML = copyright;
            } else {
              slideNode.querySelector(".gslide-copyright-wrapper").remove();
            }
            const gradient = slideConfig.gradient;
            if (gradient) {
              slideNode
                .querySelector(".gslide-media")
                .classList.add("-gradient");
            }
          });
          this.lightbox2.on("slide_before_load", (slide) => {
            const { slideIndex, slideNode, slideConfig } = slide;
            // console.log(slide);
            const gradient = slideConfig.gradient;
            if (gradient) {
              slideNode
                .querySelector(".gslide-media")
                .classList.add("-gradient");
            }
          });
          // console.log(this.lightbox2.elements);
          const lightbox2Duplicates = {};
          for (const lightbox2Element of this.lightbox2.elements) {
            const filteredElements = this.lightbox2.elements.filter(
              (element) => lightbox2Element.href === element.href
            );
            if (
              filteredElements.length > 1 &&
              !lightbox2Duplicates[lightbox2Element.href]
            ) {
              lightbox2Duplicates[lightbox2Element.href] = true;
            }
          }
          for (const duplicate of Object.keys(lightbox2Duplicates)) {
            const foundIndex = this.lightbox2.elements.findIndex(
              (element) => element.href === duplicate
            );
            if (foundIndex !== -1) {
              this.lightbox2.removeSlide(foundIndex);
            }
          }
          // console.log(this.lightbox2.elements);
        }, 0);
      });
    },
    openProductImage(productImage) {
      // console.log(productImage);
      for (const [
        index,
        lightbox2Element,
      ] of this.lightbox2.elements.entries()) {
        // console.log(lightbox2Element);
        if (lightbox2Element.href.endsWith(productImage)) {
          this.lightbox2.openAt(index);
          break;
        }
      }
    },
    splitOrEmpty(string) {
      let result = [];
      if (typeof string === "string") {
        result = string.split(",");
        if (result[0] === "") {
          result = [];
        }
      }
      return result;
    },
    fillData() {
      if (this.completeProduct) {
        this.product = this.completeProduct.attributes;
        // Kategorien
        this.categories = [];
        const categories = this.completeProduct.relationships?.Kategorie?.data;
        if (categories) {
          for (const category of categories) {
            this.categories.push({
              id: category.attributes.id,
              titel: category.attributes.titel,
              titel_en: category.attributes.titel_en,
            });
          }
        }
        // Zubehör
        this.equipment = [];
        let equipment = this.completeProduct.relationships?.zubehoer?.data;
        if (equipment) {
          for (let entry of equipment) {
            this.equipment.push(entry.attributes);
          }
        }
        // Treiber
        this.drivers = [];
        let drivers = this.completeProduct.relationships?.drivers?.data;
        if (drivers) {
          for (let driver of drivers) {
            // console.log(driver);
            if (driver.attributes.code.includes("*")) {
              this.showPrimaryWiring = true;
            }
            driver.attributes.dimmable = this.splitOrEmpty(
              driver.attributes.dimmable_text
            );
            const constants = this.splitOrEmpty(
              driver.attributes.constant_text
            );
            const power = this.splitOrEmpty(driver.attributes.power_text);
            if (power.length + 1 === constants.length) {
              power.push(power[power.length - 1]);
            }
            const selectedConstants = this.splitOrEmpty(
              this.product.constant_text
            );
            if (selectedConstants.length > 0) {
              const newConstants = [];
              const newPower = [];
              for (const selectedConstant of selectedConstants) {
                for (const [index, constant] of constants.entries()) {
                  if (constant.includes(selectedConstant)) {
                    newConstants.push(constant);
                    newPower.push(power[index]);
                  }
                }
                driver.attributes.constant = newConstants;
                driver.attributes.power = newPower;
              }
            } else {
              driver.attributes.constant = constants;
              driver.attributes.power = power;
            }
            // console.log(constant);
            // console.log(power);
            this.drivers.push(driver.attributes);
          }
        }
        // Galerie Bilder
        this.gallery = [];
        if (this.product.galerie) {
          if (this.product.galerie.includes(",")) {
            this.gallery = this.product.galerie.split(",");
          } else {
            this.gallery.push(this.product.galerie);
          }
        }

        // Galerie Bilder Copyrights
        for (const filename of this.gallery) {
          this.axios.get("media/?filename=" + filename).then((response) => {
            if (response.status === 200) {
              const file = response.data.data[0]?.attributes;
              // console.log(file);
              if (file) {
                if (this.lang === "en") {
                  this.$set(this.copyrights, filename, file.med_copyright_en);
                } else {
                  this.$set(this.copyrights, filename, file.med_copyright);
                }
              }
            }
          });
        }

        // Icons
        this.icons = [];
        if (this.product.icons_test) {
          if (this.product.icons_test.includes(",")) {
            this.icons = this.product.icons_test.split(",");
          } else {
            this.icons.push(this.product.icons_test);
          }
        }
        // Farbbilder
        this.colorImages = [];
        if (this.product.farbbilder) {
          if (this.product.farbbilder.includes(",")) {
            this.colorImages = this.product.farbbilder.split(",");
          } else {
            this.colorImages.push(this.product.farbbilder);
          }
        }
        // Farbbezeichnungen
        this.colorNames = [];
        this.colorChips = [];
        // this.colorNamesMapping = {};
        const colorNameIds = this.product.farbbildbezeichnungen_value.split(
          ","
        );
        // console.log(colorNameIds);
        let colorNames = this.completeProduct.relationships
          ?.farbbildbezeichnungen?.data;
        // console.log(colorNames);
        if (colorNameIds?.length) {
          for (let colorNameId of colorNameIds) {
            const colorName = colorNames?.find((obj) => {
              return obj.id == colorNameId;
            });
            if (colorName) {
              this.colorChips.push(colorName.attributes?.farbchips);
              if (this.lang === "en") {
                this.colorNames.push(colorName.attributes?.bezeichnung_en);
              } else {
                this.colorNames.push(colorName.attributes?.bezeichnung);
              }
            }
          }
        } else if (colorNames) {
          for (let colorName of colorNames) {
            // console.log(colorName.attributes?.farbchips);
            this.colorChips.push(colorName.attributes?.farbchips);
            // this.colorNamesMapping[
            //   this.product.titel +
            //     "&nbsp;&nbsp;" +
            //     colorName.attributes?.bezeichnung_en.split(" / ")[0]
            // ] =
            //   this.product.titel +
            //   "&nbsp;&nbsp;" +
            //   colorName.attributes?.bezeichnung.split(" / ")[0];
            if (this.lang === "en") {
              this.colorNames.push(colorName.attributes?.bezeichnung_en);
            } else {
              this.colorNames.push(colorName.attributes?.bezeichnung);
            }
          }
        }
        this.colorNamesAddition = [];
        if (this.product.farbbildzusatz) {
          this.colorNamesAddition = JSON.parse(this.product.farbbildzusatz);
        }
        this.colorImagesHover = [];
        if (this.product.farbbilder_hover) {
          this.colorImagesHover = JSON.parse(this.product.farbbilder_hover);
        }
        // if (this.product.farbbezeichnungen) {
        //     if (this.product.farbbezeichnungen.includes(",")) {
        //         this.colorNames = this.product.farbbezeichnungen.split(
        //             ","
        //         );
        //     } else {
        //         this.colorNames.push(this.product.farbbezeichnungen);
        //     }
        // }
        // Tabellen
        this.table = JSON.parse(this.product.tabelle);
        this.tableCri = JSON.parse(this.product.tabelle_cri);
        this.tableH = JSON.parse(this.product.tabelle_h);

        // tableByType Befüllung
        this.tableByType = {};
        this.fillTableByType(this.table, this.tableByType);

        // tableCriByType Befüllung
        this.tableCriByType = {};
        this.fillTableByType(this.tableCri, this.tableCriByType);

        // tableHByType Befüllung
        this.tableHByType = {};
        this.fillTableByType(this.tableH, this.tableHByType);
        if (this.tableH.length > 0) {
          this.showHInfo = true;
        }

        // Abstrahlwinkel
        // console.log(this.product.abstrahlwinkel);
        if (this.product.abstrahlwinkel) {
          const abstrahlwinkel = JSON.parse(this.product.abstrahlwinkel);
          this.beamAngles = {};
          for (const row of abstrahlwinkel) {
            // console.log(row);
            if (this.beamAngles[row[0]]) {
              this.beamAngles[row[0]].push({ angle: row[1], addition: row[2] });
            } else {
              this.beamAngles[row[0]] = [{ angle: row[1], addition: row[2] }];
            }
          }
        }

        this.colors = this.completeProduct.relationships?.farben?.data;
        this.initializeLightbox();
      }
    },
    fillTableByType(src, dest) {
      for (let rowKey in src) {
        let row = [...src[rowKey]];
        if (row[0].trim()) {
          let type = row[1] + "&nbsp;&nbsp;" + row[2];
          if (!dest[type]) {
            this.$set(dest, type, []);
          }
          let lumenValue = row[4].trim();
          if (lumenValue && lumenValue !== "-") {
            this.showLumenInfo = true;
          }
          row.splice(1, 2);
          dest[type].push(row);
        }
      }
    },
  },
  computed: {
    productImage() {
      let result = "";
      if (this.product.produktbild_transparent) {
        result = this.imageurl + this.product.produktbild_transparent;
      } else if (this.product.produktbild) {
        result = this.imageurl + this.product.produktbild;
      }
      return result;
    },
    headTitle() {
      let headTitle = undefined;
      let category = "";
      if (this.art) {
        if (this.lang === "en") {
          category = this.categories.find(
            (obj) => window.toSlug(obj.titel_en) === this.art
          )?.titel_en;
        } else {
          category = this.categories.find(
            (obj) => window.toSlug(obj.titel) === this.art
          )?.titel;
          if (category?.[category.length - 1] === "n") {
            category = category.slice(0, -1);
          }
        }
      }
      const categoryString = category ? " - " + category : "";
      if (this.product.titel) {
        headTitle = this.product.titel + categoryString + " - DLS Lighting";
      }
      return headTitle;
    },
    isChipInColorImages() {
      for (let [index, colorImage] of this.colorImages.entries()) {
        if (colorImage === this.colorChips[index]) {
          return true;
        }
      }
      return false;
    },
    flatProductTitle() {
      return this.product.titel
        .toLowerCase()
        .replaceAll(" ", "-")
        .replace("(", "")
        .replace(")", "");
    },
    driverVersions() {
      let result = {};
      for (const driver of this.drivers) {
        const versions = this.splitOrEmpty(driver.versions);
        const lights = this.splitOrEmpty(driver.lights_number);
        const versionConstants = this.splitOrEmpty(driver.versionConstants);
        const versionPowers = this.splitOrEmpty(driver.versionPowers);
        const constants = driver.constant;
        const powers = driver.power;
        if (versions.length === 0) {
          versions = ["-"];
        }
        for (const [index, version] of versions.entries()) {
          const changedDriver = { ...driver };
          changedDriver.light = lights[index];
          if (versions[0] !== "-") {
            if (versions.length < constants.length || !constants[index]) {
              changedDriver.constant = [constants[constants.length - 1]];
              changedDriver.power = [powers[powers.length - 1]];
            } else {
              changedDriver.constant = [constants[index]];
              changedDriver.power = [powers[index]];
            }
          }
          if (versionConstants.length > 0) {
            changedDriver.constant = [versionConstants[index]];
          }
          if (versionPowers.length > 0) {
            changedDriver.power = [versionPowers[index]];
          }
          if (result[version]) {
            result[version].push(changedDriver);
          } else {
            result[version] = [changedDriver];
          }
        }
      }
      return result;
    },
    lang() {
      return this.$store.state.lang;
    },
    completeProduct() {
      if (isNaN(parseInt(this.id))) {
        const foundProduct = Object.values(this.$store.state.products).find(
          (obj) => {
            return window.toSlug(obj.attributes.titel) === this.id;
          }
        );
        return foundProduct;
      } else {
        return this.$store.state.products[this.id];
      }
    },
    lumenText() {
      let result = "Lumen";
      if (this.showLumenInfo) {
        result = "Lumen*";
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
// background for transparent sketches
.gslide .gslide-image.-gradient {
  background: linear-gradient(#929292, #f2f2f2);
}
.-ground .gslide:first-of-type .gslide-image {
  background: linear-gradient(#f2f2f2, #929292);
}
.gslide-image {
  background: white;
  position: relative;
  .gslide-copyright-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 21px;
    padding: 5px 10px;
    transition: background 0.3s;
    &:hover {
      background: $grey-dark;
      .gslide-copyright {
        opacity: 1;
      }
    }
    .gslide-copyright {
      // position: absolute;
      // bottom: 30px;
      // white-space: nowrap;
      // background: $grey-dark;
      // left: -10px;
      // padding-left: 10px;
      // padding-right: 10px;
      opacity: 0;
      // pointer-events: none;
      display: inline-block;
      font-size: 16px;
      transition: opacity 0.3s;
    }
  }
}

.c-productpage {
  &__text {
    @include media-breakpoint-up(lg) {
      min-height: 295px;
    }
    @include media-breakpoint-up(xl) {
      min-height: 364px;
    }
    @include media-breakpoint-down(md) {
      order: 1;
      margin-top: 30px;
    }
    &.-colorchips {
      @include media-breakpoint-up(lg) {
        min-height: 368px;
      }
      @include media-breakpoint-up(xl) {
        min-height: 452px;
      }
    }
  }
  img {
    display: inline-block;
  }
  .u-grid-column-last {
    grid-column: -2/-1;
  }
  .c-image-wrapper {
    position: relative;
    display: inline-block;
    // width: 450px;
    // max-width: 100%;
    // width: 100%;
    margin-bottom: 10px;

    // padding-bottom: 100%;
    background: linear-gradient(#929292, #f2f2f2);

    &.-ground {
      background: linear-gradient(#f2f2f2, #929292);
    }
  }
  .c-image {
    display: block;
    // margin-bottom: 16px;
    // width: 100%;
    // max-width: 100%;
    // width: 445px;

    // width: 200px;
    // position: absolute;
    // inset: 0;
    // margin: auto;

    height: auto;

    @include media-breakpoint-down(md) {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .c-cutout {
    // position: absolute;
    // bottom: 10px;
    // right: 10px;
    text-align: center;
    font-size: 12px;
    line-height: 1.2;

    display: inline-block;
  }
  .c-thumbs {
    // max-width: 500px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(5rem, 1fr));
    gap: 4px;
    @include media-breakpoint-down(md) {
      grid-template-columns: repeat(auto-fill, minmax(4rem, 1fr));
      margin-left: auto;
      margin-right: auto;
    }
    &__imagewrapper {
      background: linear-gradient(#929292, #f2f2f2);
      &.-ground {
        background: linear-gradient(#f2f2f2, #929292);
      }
    }
    &__image {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      // height: 85px;
      // width: 85px;
      margin-right: 5px;
      // display: inline-block;
      border: 1px solid $grey-dark;
      padding-bottom: 100%;
      width: 100%;

      &[lazy="loading"] {
        background-size: 50%;
      }

      &.-sketch {
        background-size: 180px;
        background-position: inherit;
      }
      &.-sketch-centered {
        background-size: auto;
      }
    }
  }
  .c-colors {
    margin-top: 25px;

    @include media-breakpoint-down(md) {
      margin-top: 10px;
    }

    &.-mb-collapsible {
      @include media-breakpoint-up(lg) {
        //   position: absolute;
        //   bottom: 130px;
        // margin-bottom: 53px;
      }
    }
    @include media-breakpoint-up(lg) {
      //   position: absolute;
      //   bottom: 130px;
      // margin-bottom: 98px;
    }
    &__title {
      font-size: 15px;
      font-weight: bold;
      //   margin-bottom: 5px;
    }
    &__image-wrapper {
      display: inline-block;

      background: linear-gradient(#929292, #f2f2f2);
      &.-ground {
        background: linear-gradient(#f2f2f2, #929292);
      }
    }
    &__image {
      display: block;
      height: auto;
    }
    &__name {
      font-size: 12px;
      line-height: 1.4em;
      padding-bottom: 10px;
      // position: absolute;
    }
    img {
      border: 1px solid $grey-dark;
    }
  }
  .c-details {
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
  // .c-drivers {
  //     &__tableheader {
  //         border-bottom: 1px solid $grey-dark;
  //     }
  // }
  .c-highlight {
    font-size: 22px;
    color: $grey-darker;
    padding: 40px 15px 20px 15px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .c-icon {
    margin-right: 10px;
    display: inline-block;
    height: 46px;
  }
  .c-tableinfo {
    font-size: 0.7rem;
    margin-top: 20px;
  }

  .c-drivers {
    &__grid {
      display: grid;
      grid-template-columns: repeat(6, auto);
      // grid-gap: 10px;
      column-gap: 10px;

      @include media-breakpoint-down(sm) {
        grid-template-columns: repeat(4, auto);
      }

      > div {
        padding: 10px 0px 10px 0;
      }
    }
    &__tableheader {
      // border-bottom: 1px solid $grey-dark;
      // text-transform: uppercase;
      font-weight: bold;
      padding: 20px 10px 20px 0;
    }
  }
  .c-reference {
    margin-top: 80px;
    margin-bottom: 80px;
  }
}
</style>
